import axios from 'axios';
import { getRequiredConfig } from './service-discovery';
const createClient = () => {
    const { apiUrl } = getRequiredConfig();
    return axios.create({
        baseURL: apiUrl,
        timeout: 120000,
    });
};
// Create a client instance that uses current config
const client = {
    get: (url, config) => createClient().get(url, config),
    post: (url, data, config) => createClient().post(url, data, config),
    put: (url, data, config) => createClient().put(url, data, config),
    delete: (url, config) => createClient().delete(url, config),
    patch: (url, data, config) => createClient().patch(url, data, config),
};
export default client;
